import { render } from "./ResonForChange.vue?vue&type=template&id=04377d5d"
import script from "./ResonForChange.vue?vue&type=script&lang=js"
export * from "./ResonForChange.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/misc/ResonForChange.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04377d5d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04377d5d', __exports__)) {
    console.log('reload')
    api.reload('04377d5d', __exports__)
  }
  
  module.hot.accept("./ResonForChange.vue?vue&type=template&id=04377d5d", () => {
    console.log('re-render')
    api.rerender('04377d5d', render)
  })

}


export default __exports__